import { Button } from "@/components/ui/button";
import { Mic, Square } from "lucide-react";
import { Loader2 } from "lucide-react";
import { useState, useEffect } from "react";
import { RetellWebClient } from "retell-client-js-sdk";
import { useAuth } from "@/components/AuthProvider";
import { TranscriptMessage } from "./Chat";

const agentId = "agent_d0e15c1f33c86d6796cf6044c2";
const apiKey = 'key_060af72f97e3a396c3f76a083966'

interface RegisterCallResponse {
  access_token: string;
}

const retellWebClient = new RetellWebClient();

interface ChatInputProps {
  onSendMessage: (message: string) => void;
  onTranscriptUpdate: (transcript: TranscriptMessage[]) => void;
}

export const ChatInput = ({ onSendMessage, onTranscriptUpdate, onConversationStart }: ChatInputProps) => {
  const [isCalling, setIsCalling] = useState(false);
  const [isConnecting, setIsConnecting] = useState(false);

  const { session } = useAuth();

  useEffect(() => {
    retellWebClient.on("call_started", () => {
      console.log("call started");
    });
    
    retellWebClient.on("call_ended", () => {
      console.log("call ended");
      setIsCalling(false);
    });
    
    retellWebClient.on("agent_start_talking", () => {
      console.log("agent_start_talking");
    });
    
    retellWebClient.on("agent_stop_talking", () => {
      console.log("agent_stop_talking");
    });
    
    retellWebClient.on("audio", (audio) => {
      // console.log(audio);
    });
    
    retellWebClient.on("update", (update) => {
      if (update.transcript) {
        onTranscriptUpdate(update.transcript);
      }
    });
    
    retellWebClient.on("metadata", (metadata) => {
      // console.log(metadata);
    });
    
    retellWebClient.on("call_started", () => {
      console.log("call started");
      setIsConnecting(false);
    });
  }, [onTranscriptUpdate]);

  const toggleConversation = async () => {
    if (isCalling) {
      retellWebClient.stopCall();
    } else {
      setIsConnecting(true);
      onConversationStart();
      try {
        const registerCallResponse = await registerCall(agentId);
        if (registerCallResponse.access_token) {
          await retellWebClient.startCall({
            accessToken: registerCallResponse.access_token,
          });
          setIsCalling(true);
        }
      } catch (error) {
        console.error(error);
        setIsConnecting(false);
      }
    }
  };
  async function registerCall(agentId: string): Promise<RegisterCallResponse> {
    try {
      console.log("Registering call..., ", session);
      const response = await fetch("https://api.retellai.com/v2/create-web-call", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${apiKey}`,
        },
        body: JSON.stringify({
          agent_id: agentId,
          metadata: { userId: session.user.id },
        }),
      });
  
      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }
  
      const data: RegisterCallResponse = await response.json();
      return data;
    } catch (err) {
      console.log(err);
      throw new Error(err);
    }
  }

  return (
    <div className="py-4 border-t bg-background">
      <Button 
        type="button" 
        size="icon" 
        className="w-full"
        variant={isCalling ? "destructive" : "default"}
        onClick={toggleConversation}
        disabled={isConnecting}
      >
        {isConnecting ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : isCalling ? (
          <Square className="h-4 w-4" />
        ) : (
          <Mic className="h-4 w-4" />
        )}
      </Button>
    </div>
  );
};
